import { type ApiErrorBody, apiErrorSchema } from '@orderlymeds/measurements-schemas';

export class ApiClientError extends Error {
	readonly status: number;
	readonly code: string;
	readonly requestId?: string;
	readonly body: ApiErrorBody | null;
	readonly rawText: string;

	constructor(status: number, body: ApiErrorBody | null, rawText: string) {
		super(body?.message ?? body?.error ?? `API ${status}`);
		this.name = 'ApiClientError';
		this.status = status;
		this.code = body?.error ?? 'api_error';
		this.requestId = body?.request_id;
		this.body = body;
		this.rawText = rawText;
	}
}

export function isApiClientError(err: unknown): err is ApiClientError {
	return err instanceof ApiClientError;
}

export async function parseApiErrorResponse(res: Response): Promise<ApiClientError> {
	const rawText = await res.text().catch(() => '');
	let body: ApiErrorBody | null = null;
	if (rawText) {
		try {
			const parsed = JSON.parse(rawText);
			const result = apiErrorSchema.safeParse(parsed);
			body = result.success ? result.data : null;
		} catch {
			/* body stays null */
		}
	}
	return new ApiClientError(res.status, body, rawText);
}
